<div class="light">
  <app-navbar class="light"></app-navbar>

  <form [formGroup]="form">
    <section [formGroup]="form">
      <div class="container">
        <h1>Заявка на изготовление цифрового памятника</h1>

        <div class="row mb-3">
          <div class="col-12">
            <!-- ­­­­­­­­­­­­­­­­­­­­­­­­­­­­­­­­­­­­­­­ Accordion -->
            <div class="accordion" id="accordionExample1">
              <!-- ─────────── 1. Личные данные ─────────── -->
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                  <button
                    class="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    Личные данные
                    <img
                      src="assets/info-icon.svg"
                      alt=""
                      [tooltip]="personal_data_tpl"
                      containerClass="custom-tooltip"
                      placement="end"
                      triggers="hover"
                      class="ms-2"
                    />
                  </button>
                </h2>

                <ng-template #personal_data_tpl>
                  <b>Личные данные.</b> Введите информацию об усопшем. Не
                  обязательно заполнять все поля — можно указать даже просто имя
                  для надгробия, если не хотите перечислять всех отдельно.
                  Вносите данные в любые поля шаблона. Как будут выглядеть ваши
                  записи — сразу видно в предпросмотре.
                </ng-template>

                <div
                  id="collapseOne"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                >
                  <div class="accordion-body">
                    <!-- ------------ ФОРМА ------------ -->
                    <div class="form">
                      <!-- Имя -->
                      <div class="row form-item custom-form-field">
                        <div class="col-12 form-input">
                          <div
                            class="error"
                            *ngIf="
                              form.get('firstName')?.invalid &&
                              form.get('firstName')?.touched
                            "
                          >
                            Обязательное поле
                          </div>
                          <input
                            type="text"
                            formControlName="firstName"
                            placeholder="Имя *"
                          />
                        </div>
                      </div>

                      <!-- Фамилия -->
                      <div class="row form-item custom-form-field">
                        <div class="col-12 form-input">
                          <div
                            class="error"
                            *ngIf="
                              form.get('lastName')?.invalid &&
                              form.get('lastName')?.touched
                            "
                          >
                            Обязательное поле
                          </div>
                          <input
                            type="text"
                            formControlName="lastName"
                            placeholder="Фамилия *"
                          />
                        </div>
                      </div>

                      <!-- Отчество -->
                      <div class="row form-item custom-form-field">
                        <div class="col-12 form-input">
                          <input
                            type="text"
                            formControlName="patronymic"
                            placeholder="Отчество"
                          />
                        </div>
                      </div>

                      <!-- Даты -->
                      <div class="row form-item custom-form-field">
                        <div
                          class="col-lg-6 col-sm-12 form-input position-relative"
                        >
                          <input
                            matInput
                            [matDatepicker]="bd"
                            formControlName="birthDate"
                            readonly
                            placeholder="Дата рождения"
                          />
                          <mat-datepicker-toggle
                            matIconSuffix
                            [for]="bd"
                            class="position-absolute"
                            style="top: 4px; right: 16px; width: 50px"
                          ></mat-datepicker-toggle>
                          <mat-datepicker #bd></mat-datepicker>
                        </div>

                        <div
                          class="col-lg-6 col-sm-12 form-input position-relative"
                        >
                          <input
                            matInput
                            [matDatepicker]="dd"
                            formControlName="deathDate"
                            readonly
                            placeholder="Дата смерти"
                          />
                          <mat-datepicker-toggle
                            matIconSuffix
                            [for]="dd"
                            class="position-absolute"
                            style="top: 4px; right: 16px; width: 50px"
                          ></mat-datepicker-toggle>
                          <mat-datepicker #dd></mat-datepicker>
                        </div>
                      </div>

                      <!-- Место погребения -->
                      <div class="row form-item custom-form-field">
                        <div class="col-12 form-input">
                          <!-- сообщение об ошибке -->
                          <div
                            class="error"
                            *ngIf="
                              form.get('burialPlace')?.touched &&
                              form.get('burialPlace')?.errors as e
                            "
                          >
                            <span class="error" *ngIf="e['required']"
                              >Обязательное поле</span
                            >
                            <span class="error" *ngIf="e['coords']">
                              Координаты должны быть в формате «широта, долгота»
                              (-90…90, -180…180)
                            </span>
                          </div>

                          <div class="input-group position-relative">
                            <input
                              class="form-control"
                              formControlName="burialPlace"
                              placeholder="Место погребения (координаты)"
                            />
                            <button
                              class="btn bg-transparent location-btn"
                              (click)="toggleMap()"
                            >
                              <img
                                [src]="
                                  showMap
                                    ? 'assets/close-map-icon.svg'
                                    : 'assets/Location.svg'
                                "
                                alt=""
                              />
                            </button>
                          </div>
                        </div>
                      </div>

                      <!-- Карта -->
                      <div class="row form-item" *ngIf="showMap">
                        <div class="col-12 form-input" style="height: 600px">
                          <ya-map
                            [center]="mapCenter"
                            [zoom]="zoom"
                            width="100%"
                            height="600px"
                            (ready)="onMapReady($event)"
                            class="map-class"
                          ></ya-map>
                        </div>
                      </div>

                      <!-- Загрузка файлов -->
                      <div style="margin-bottom: 16px">
                        <app-drag-n-drop
                          [files]="form.get('files')!.value"
                          (filesChange)="onFilesAdded($event)"
                          [filesLimit]="true"
                        ></app-drag-n-drop>
                      </div>

                      <!-- Биография -->
                      <quill-editor
                        style="width: 100%"
                        format="html"
                        formControlName="descriptionHtml"
                        placeholder="Текст биографии"
                      ></quill-editor>
                    </div>
                    <!-- ---------- /ФОРМА ---------- -->
                  </div>
                </div>
              </div>

              <!-- ─────────── 2. Данные заказчика ─────────── -->
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingTwo">
                  <button
                    class="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="true"
                    aria-controls="collapseTwo"
                  >
                    Данные заказчика
                    <img
                      src="assets/info-icon.svg"
                      alt=""
                      [tooltip]="customer_data_tpl"
                      containerClass="custom-tooltip"
                      placement="auto"
                      triggers="hover"
                      class="ms-2"
                    />
                  </button>
                </h2>

                <ng-template #customer_data_tpl>
                  <b>Данные заказчика.</b>
                </ng-template>

                <div
                  id="collapseTwo"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingTwo"
                >
                  <div class="accordion-body">
                    <div class="form">
                      <!-- Имя заказчика -->
                      <div class="row form-item custom-form-field">
                        <div class="col-12 form-input">
                          <div
                            class="error"
                            *ngIf="
                              form.get('customerFirstName')?.invalid &&
                              form.get('customerFirstName')?.touched
                            "
                          >
                            Обязательное поле
                          </div>
                          <input
                            type="text"
                            formControlName="customerFirstName"
                            placeholder="Имя *"
                          />
                        </div>
                      </div>

                      <!-- Фамилия заказчика -->
                      <div class="row form-item custom-form-field">
                        <div class="col-12 form-input">
                          <div
                            class="error"
                            *ngIf="
                              form.get('customerLastName')?.invalid &&
                              form.get('customerLastName')?.touched
                            "
                          >
                            Обязательное поле
                          </div>
                          <input
                            type="text"
                            formControlName="customerLastName"
                            placeholder="Фамилия *"
                          />
                        </div>
                      </div>

                      <!-- Отчество заказчика -->
                      <div class="row form-item custom-form-field">
                        <div class="col-12 form-input">
                          <input
                            type="text"
                            formControlName="customerPatronymic"
                            placeholder="Отчество"
                          />
                        </div>
                      </div>

                      <!-- Номер телефона -->
                      <div class="row form-item custom-form-field">
                        <div class="col-12 form-input">
                          <span
                            class="error"
                            *ngIf="
                              form.get('phoneNumber')?.invalid &&
                              form.get('phoneNumber')?.touched
                            "
                          >
                            Обязательное поле
                          </span>
                          <span
                            class="error"
                            *ngIf="form.get('phoneNumber')!.errors?.['pattern']"
                          >
                            Неверный формат номера
                          </span>
                          <input
                            type="tel"
                            inputmode="tel"
                            autocomplete="tel"
                            formControlName="phoneNumber"
                            placeholder="Номер телефона *"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- ─────────── /item 2 ─────────── -->
            </div>
            <!-- /accordion -->
          </div>
        </div>

        <div>
          <div
            class="error"
            *ngIf="
              form.get('agreement')?.invalid && form.get('agreement')?.touched
            "
          >
            Обязательное поле
          </div>
          <mat-checkbox formControlName="agreement">
            <div class="checkbox-label">
              Я даю согласие на использование моей персональной информации для
              обработки запроса в соответствии с
              <a
                style="text-decoration: underline"
                target="_blank"
                href="https://nekrolog.by/docs/company_policy_ru.pdf"
                >Политикой конфиденциальности Компании</a
              >
            </div>
          </mat-checkbox>
        </div>
        <div class="mb-4">
          <div
            class="error"
            *ngIf="
              form.get('termsOfOffer')?.invalid &&
              form.get('termsOfOffer')?.touched
            "
          >
            Обязательное поле
          </div>
          <mat-checkbox formControlName="termsOfOffer">
            <div class="checkbox-label">
              Я ознакомлен(а) и согласен(а) с
              <a
                style="text-decoration: underline"
                target="_blank"
                href="https://nekrolog.by/docs/agreement_ru.pdf"
                >условиями Оферты</a
              >
            </div>
          </mat-checkbox>
        </div>

        <!-- <div
          class="error"
          *ngIf="form.get('captcha')?.invalid && form.get('captcha')?.touched"
        >
          Обязательное поле
        </div> -->
        <!-- <re-captcha
          formControlName="captcha"
          siteKey="{{ captchaSiteKey }}"
          (resolved)="onCaptchaResolved($event)"
        >
        </re-captcha> -->
        <div class="pay-btn-container">
          <button class="pay-btn" (click)="onCreateConfirm()">Оплатить</button>
        </div>
      </div>
    </section>
  </form>

  <app-faq class="lighter"></app-faq>
  <app-contacts class="light"></app-contacts>
  <app-footer class="lightest"></app-footer>
</div>
